import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
const GenericTooltip = (props) => {
    const [show, setShow] = useState(false);
    const [isToggle, setIsToggle] = useState(props.isExist);
    useEffect(() => {
        if (Object(props).hasOwnProperty("isExist")) {
            setShow(props.isExist);
            setIsToggle(props.isExist);
        }
    }, [props.isExist]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: props.externalClassName }, props.triggerType === "hover" ? (React.createElement(OverlayTrigger, Object.assign({ trigger: ["hover", "focus"], key: props.placement, placement: props.placement, show: props === null || props === void 0 ? void 0 : props.show, overlay: React.createElement(Tooltip, { id: "overlay-example", className: props.toolTipClassName }, props.toolTipText) }, (props.container && { container: props.container })),
            React.createElement(Button, { onClick: () => setShow(!show) }, props.button))) : (React.createElement(OverlayTrigger, Object.assign({ container: () => document.getElementById("tooltip-container"), show: show, onToggle: () => setIsToggle(false), trigger: "click", key: props.placement, placement: props.placement, overlay: React.createElement(Tooltip, { id: "overlay-example", className: `${props.toolTipClassName} ${isToggle && "d-none"}` }, props.toolTipText) }, (props.container && { container: props.container })),
            React.createElement(Button, { onClick: () => setShow(!show) }, show
                ? props.onShowbutton
                    ? props.onShowbutton
                    : props.button
                : props.button))))));
};
export default GenericTooltip;
